import { render, staticRenderFns } from "./stockStatus.vue?vue&type=template&id=5c2ef09c&scoped=true"
import script from "./stockStatus.vue?vue&type=script&lang=js"
export * from "./stockStatus.vue?vue&type=script&lang=js"
import style0 from "./stockStatus.vue?vue&type=style&index=0&id=5c2ef09c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2ef09c",
  null
  
)

export default component.exports